import type { Locale } from "./translations";
export const LANGUAGE_PAIRS = [["/", "/en"], ["/sobre-el-libro", "/about-the-book"], ["/edmundo-trevino", "/about-edmundo"]] as const;
export function cleanPath(path: string): string { return path.split(/[?#]/)[0].replace(/\/+$/, "") || "/"; }
export function localeForPath(path: string): Locale { return LANGUAGE_PAIRS.some(pair => pair[1] === cleanPath(path)) ? "en" : "es"; }
export function translatedPath(path: string, locale: Locale): string {
  const pair = LANGUAGE_PAIRS.find(pair => pair.some(p => p === cleanPath(path)));
  // Blog posts and reader submissions have no English translation.
  return pair ? pair[locale === "en" ? 1 : 0] : locale === "en" ? "/en" : "/";
}
